module.exports = __webpack_public_path__ + "img/son.17a4671a.svg";